import styled from 'styled-components';
import { theme, minBp } from '@triumph/shared';
import Container from 'components/_utility/Container';

export const Page = styled.main`
  padding: 0 0 25px;

  @media ${minBp('desktop')} {
    padding: 70px 0 45px;
  }
`;

export const HeadingWrap = styled(Container)`
  padding: 0 20px;
  display: ${({ mobile }) => (mobile ? 'block' : 'none')};

  @media ${minBp('desktop')} {
    display: flex;
    flex-direction: column-reverse;
    display: ${({ desktop }) => (desktop ? 'block' : 'none')};
  }
`;

export const Wrap = styled(Container)`
  padding: 0 20px;
`;

export const Terms = styled.div`
  border-top: 1px solid ${theme.colors.outline};
  padding-top: 24px;
`;

export const TermsInner = styled.div`
  max-width: 810px;
  margin: 0 auto;
  text-align: center;
`;

export const TermsTitle = styled.h6`
  font-size: 16px;
  font-family: ${theme.fonts.dinDemi};
  text-transform: uppercase;
  line-height: 20px;
  margin: 0 0 24px;
`;

export const TermsBody = styled.div`
  font-size: 13px;
  line-height: 20px;

  @media ${minBp('desktop')} {
    font-size: 14px;
    line-height: 24px;
  }

  p {
    margin: 0 0 20px;
  }
`;
